// تبدیل «تاریخ کسب‌وکاری» انتخاب‌شده در DatePicker شمسی به لحظه UTC برای فیلترها و انقضا (ADR-014: منطقه زمانی در لبه).
import { DEFAULT_TIME_ZONE } from '@phoenix/ui';

function offsetMinutes(instant: Date, timeZone: string): number {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  }).formatToParts(instant);
  const get = (type: Intl.DateTimeFormatPartTypes) =>
    Number(parts.find((p) => p.type === type)?.value ?? '0');
  const wall = Date.UTC(get('year'), get('month') - 1, get('day'), get('hour'), get('minute'));
  return Math.round((wall - instant.getTime()) / 60_000);
}

/** آغاز روز `yyyy-MM-dd` در منطقه زمانی داده‌شده به‌صورت ISO UTC؛ `addDays` برای پایان بازه (آغاز روز بعد). */
export function startOfBusinessDayIso(date: string, timeZone = DEFAULT_TIME_ZONE, addDays = 0): string {
  const [year, month, day] = date.split('-').map(Number) as [number, number, number];
  const utcMidnight = new Date(Date.UTC(year, month - 1, day + addDays));
  const offset = offsetMinutes(utcMidnight, timeZone);
  return new Date(utcMidnight.getTime() - offset * 60_000).toISOString();
}
